import { SolrSearchRegion, SolrSearchType } from "../types/search.types";

export const GRAPHICS_API = "/search/filter/image-themes";
export const REPORTS_API = "/search/filter/page-sections";
export const SOLR_SEARCH_API = (route: SolrSearchRegion) => `/search/${route}`;

export const GET_FULLDOCS_COMPANIES_API = "/search/FullDocumentCompany";
export const GET_COMPANIES_BY_DISCLOSURE_API = "/search/solr-fulldocsearch-fr-new-filter";

// FILTERS API
export const GET_ALL_COMPANIES_API = "/search/filter/company";
export const GET_ALL_INDUSTRIES_API = "/search/filter/industries";
export const GET_FILTER_OPTIONS_API = (type: SolrSearchType, region: string) =>
    `/search/solr-${type}-${region}-new-filter`;
